import whatsappIcon from "../assets/whatsapp.png";
import { FaWhatsapp } from "react-icons/fa";


function WhatsAppButton() {
  return (
    <a
      className="whatsapp"
      href="https://wa.me/447826699446?text=Hello%2C%20I%20am%20interested%20in%20your%20luxury%20chauffeur%20services"
      target="_blank"
      rel="noreferrer"
    >
      <>
        {/* <img src={whatsappIcon} alt="whatsapp" className="whatsapp-icon" /> */}
        <FaWhatsapp className="whatsapp-icon" />
        <span>Book Now</span>
      </>
    </a>
  );
}

export default WhatsAppButton;